"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _components = require("components");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _auth = require("../../redux/modules/auth");

var _zendesk = require("../../redux/modules/zendesk");

var _payments = require("redux/modules/payments");

var _EducationalProgramFormValidation = require("../../utils/EducationalProgramFormValidation");

var _EducationalProgramFormValidation2 = _interopRequireDefault(_EducationalProgramFormValidation);

var _ThanksPopup = require("@quixeltools/quixel-ui-library/dist/components/megascans/popups/ThanksPopup");

var _ThanksPopup2 = _interopRequireDefault(_ThanksPopup);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EducationSubscriptionContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: "EducationalProgram",
  fields: ["name", "email", "url", "institute", "subject", "photo", "comments", "duration", "type", "work"],
  validate: _EducationalProgramFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    educationalPlan: state.subscriptions.plans,
    token: state.zendesk.token,
    uploaded: state.zendesk.uploaded,
    subscription: state.user.subscription,
    uploading: state.zendesk.uploading,
    shouldUpdateEula: state.auth.eula.updateVersion
  };
}, {
  createTicket: _zendesk.createTicket,
  cacheTicket: _zendesk.cacheTicket,
  sendCacheTicket: _zendesk.sendCacheTicket,
  initPayment: _payments.initPayment,
  uploadFile: _zendesk.uploadFile,
  acceptEULA: _auth.acceptEULA
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(EducationSubscriptionContainer, _React$Component);

  function EducationSubscriptionContainer(props) {
    (0, _classCallCheck3.default)(this, EducationSubscriptionContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EducationSubscriptionContainer.__proto__ || (0, _getPrototypeOf2.default)(EducationSubscriptionContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null,
      psrc: "",
      pvalue: "",
      pname: ""
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    _this.onChangeFile = _this.onChangeFile.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EducationSubscriptionContainer, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.psrc !== this.state.psrc) {
        this.props.uploadFile(nextState.psrc, "");
      }
    }
  }, {
    key: "onChangeFile",
    value: function onChangeFile(e) {
      e.preventDefault();
      var file = e.target.files[0];
      var reader = new FileReader();
      var self = this;

      var photoProps = this.props.fields.photo;


      photoProps.onChange(e);

      if (file) {
        self.setState({
          pname: file.name
        });

        reader.onload = function (r) {
          function toBuffer(ab) {
            var buffer = new Buffer(ab.byteLength);
            var view = new Uint8Array(ab);
            for (var i = 0; i < buffer.length; ++i) {
              buffer[i] = view[i];
            }
            return buffer;
          }
          self.setState({
            psrc: toBuffer(r.target.result)
          });
        };

        reader.readAsArrayBuffer(file);

        self.setState({ pvalue: reader });
      }
    }
  }, {
    key: "onSubmitClick",
    value: function onSubmitClick(values) {
      this.setState({
        message: null,
        error: null
      });

      var email = values.email,
          url = values.url,
          name = values.name,
          subject = values.subject,
          institute = values.institute,
          comments = values.comments,
          type = values.type,
          photo = values.photo,
          work = values.work;


      var duration = "1 Year";

      var tag = this.props.tag || "regular";

      if (type !== "Education Free") {
        var ed = _ramda2.default.reject(function (n) {
          return n.license !== "educational";
        }, this.props.educationalPlan);

        var uploadArray = [];
        if (this.props.token && this.props.token.length > 0) {
          uploadArray.push(this.props.token);
        } else {
          this.setState({
            error: true,
            message: "Please upload file."
          });
        }

        var custom_fields = [{
          id: "360000990877",
          value: "Education_Program"
        }];

        this.props.createTicket({
          email: email,
          subject: subject,
          comment: comments + "\n Institute: " + institute + "\n Duration: " + duration + "\n" + "type:" + type + "\n URL: " + url + "\nWork Info: " + work,
          tag: tag,
          name: name,
          url: url,
          uploads: uploadArray,
          custom_fields: custom_fields
        }).then(function () {
          if (window && _epicTracking) {
            window.trackEpicIntrection({
              eventCategory: "Forms",
              eventAction: "Get in Touch",
              interactionType: "click",
              eventValue: 100
            });
          }
        });
        if (this.props.shouldUpdateEula) {
          this.props.acceptEULA();
        }

        this.context.dialogs.custom(_react2.default.createElement(
          _components.AppSideEffects,
          null,
          _react2.default.createElement(_ThanksPopup2.default, {
            icon: "/quixel_logo.png",
            closePopup: this.props.onCloseYes,
            title: "Thanks!",
            description: "We\u2019ve got your info, and will get back to you soon.",
            message: "<p>We\u2019ll process your information and get you set up in the next 3-5 business days.</p> <br></br> <p>If you have any questions in the meanwhile, feel free to reach out our <a href=\"" + _config2.default.forumBaseUrl + "\">support team</a>.</p>"
          })
        ));
      } else {
        var _custom_fields = [{
          id: "360000990877",
          value: "Education_Program"
        }];

        this.props.createTicket({
          email: email,
          subject: subject,
          comment: comments + "\n Institute: " + institute + "\n Duration: " + duration + "\n" + "type:" + type + "\n URL: " + url + "\nWork Info: " + work,
          tag: tag,
          name: name,
          url: url,
          uploads: [this.props.token],
          custom_fields: _custom_fields
        }).then(function () {
          if (window && _epicTracking) {
            window.trackEpicIntrection({
              eventCategory: "Forms",
              eventAction: "Get in Touch",
              interactionType: "click",
              eventValue: 100
            });
          }
        });

        if (this.props.shouldUpdateEula) {
          this.props.acceptEULA();
        }

        this.context.dialogs.custom(_react2.default.createElement(
          _components.AppSideEffects,
          null,
          _react2.default.createElement(_ThanksPopup2.default, {
            icon: "/quixel_logo.png",
            closePopup: this.props.onCloseYes,
            title: "Thanks!",
            description: "We\u2019ve got your info, and will get back to you soon.",
            message: "<p >We\u2019ll process your information and get you set up in the next 3-5 business days.</p> <br></br> <p>If you have any questions in the meanwhile, feel free to reach out our <a href=\"" + _config2.default.forumBaseUrl + "\">support team</a>.</p>"
          })
        ));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          nameInputProps = _props$fields.name,
          emailInputProps = _props$fields.email,
          messageProps = _props$fields.comments,
          urlProps = _props$fields.url,
          instituteProps = _props$fields.institute,
          duration = _props$fields.duration,
          programTypeInputProps = _props$fields.type,
          photoProps = _props$fields.photo,
          workInfoProps = _props$fields.work,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          title = _props.title,
          description = _props.description,
          tag = _props.tag,
          label = _props.label,
          shouldUpdateEula = _props.shouldUpdateEula;


      return _react2.default.createElement(_components.EducationSubscriptionPopup, {
        icon: "/quixel_logo.png",
        nameInputProps: nameInputProps,
        emailInputProps: emailInputProps,
        urlInputProps: urlProps,
        instituteNameInputProps: instituteProps,
        durationInputProps: duration,
        programTypeInputProps: programTypeInputProps,
        photoProps: photoProps,
        workInfoProps: workInfoProps,
        MessageInputProps: messageProps,
        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),
        title: title,
        description: description,
        tag: tag,
        label: label,
        uploaded: this.props.uploaded,
        uploading: this.props.uploading,
        onChangeFile: this.onChangeFile,
        fileName: this.state.pname,
        shouldUpdateEula: shouldUpdateEula
      });
    }
  }]);
  return EducationSubscriptionContainer;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = EducationSubscriptionContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EducationSubscriptionContainer/EducationSubscriptionContainer.jsx
// module id = 2813
// module chunks = 0